import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import LazyLoad from 'react-lazyload';
import SwipeableViews from 'react-swipeable-views';
import { useStorage } from '../../hooks/use-storage';
import useWindowDimensions from '../../hooks/use-window-dimensions';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseContainerBackgroundShade } from '../../utils/manager/layout-manager';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { ProductImagePlaceholder } from '../product-image-placeholder';
import { Pagination } from './images-pagination';
import { ProductImage } from './product-image';

function Images({ data, category, onPress }) {
  const { menuLayout } = useStorage();
  const { analyticsFeatureUseEvent } = useAnalytics();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [switching, setSwitching] = useState(false);
  // const [swipeDisabled, setSwipeDisabled] = useState(false);
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const size = useMemo(
    () => (isMobile ? width : layoutDefaults.maxScreenWidth),
    [width]
  );

  const classes = useStyles({
    size,
    layout: menuLayout,
  });

  const imageLength = useMemo(() => data?.length ?? 0, [data?.length]);

  const onClick = (image) => {
    const item = image?.item;

    if (item != null) {
      onPress(category, item);
      analyticsFeatureUseEvent('category image click');
    }
  };

  const onChangeIndex = (index) => {
    analyticsFeatureUseEvent('category image swipe');
    setCurrentIndex(index);
  };

  // const onZoomChange = (zoom) => {
  //   setSwipeDisabled(zoom !== 1);

  //   // eslint-disable-next-line no-undef
  //   document.body.style.overflow = zoom !== 1 ? 'hidden' : 'scroll';
  // };

  return (
    !_.isEmpty(data) && (
      <div className={classes.container}>
        {imageLength > 1 && (
          <FadeIn className={classes.counter}>
            <div>
              {t('images.counter', {
                current: currentIndex + 1,
                length: imageLength,
              })}
            </div>
          </FadeIn>
        )}

        <FadeIn>
          {imageLength > 0 && (
            <SwipeableViews
              index={currentIndex}
              // disabled={swipeDisabled}
              hysteresis={0.1}
              threshold={20}
              resistance={false}
              enableMouseEvents
              onChangeIndex={onChangeIndex}
              onSwitching={() => setSwitching(true)}
              onTransitionEnd={() => setSwitching(false)}
            >
              {data?.map((image, index) => (
                <div className={classes.imageContainer} key={image.item.id}>
                  <LazyLoad
                    // height={size}
                    offset={size / 2}
                    placeholder={<ProductImagePlaceholder />}
                    debounce={index === 0}
                    throttle={index === 0}
                    once
                  >
                    {index <= currentIndex + 1 && index >= currentIndex - 1 && (
                      <ProductImage
                        image={image}
                        onClick={switching ? null : onClick}
                        // onZoomChange={onZoomChange}
                      />
                    )}
                  </LazyLoad>
                </div>
              ))}
            </SwipeableViews>
          )}

          {imageLength > 1 && (
            <Pagination
              dots={imageLength}
              index={currentIndex}
              // onChangeIndex={onChangeIndex}
            />
          )}
        </FadeIn>
      </div>
    )
  );
}

const useStyles = createUseStyles({
  container: {
    marginTop:
      layoutDefaults.verticalMargin + layoutDefaults.smallVerticalMargin,

    // border: '2px dashed white',
  },
  imageContainer: {
    // position: "relative",
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    // touchAction: 'pan-x pan-y',
    height: ({ size }) => size,
    backgroundColor: ({ layout }) => parseContainerBackgroundShade(layout, 7),
  },
  counter: {
    // display: "flex",

    textAlign: 'right',

    width: '100%',
    maxWidth: isMobile ? null : layoutDefaults.maxScreenWidth,

    color: 'white',
    position: 'absolute',
    pointerEvents: 'none',
    // top: layoutDefaults.smallVerticalMargin,
    textShadow: '0px 0px 2px #111',
    // right: 0,
    marginTop: layoutDefaults.verticalMargin,
    paddingRight: layoutDefaults.mainHorizontalMargin,

    zIndex: 1,
    // border: '2px solid white',
  },
});

export { Images };
